import type { ProfileConfig } from "./types";

export const carloProfileConfig: ProfileConfig = {
    benefits: null,
};
